import { render, staticRenderFns } from "./UnsubscribeTokenSettings.vue?vue&type=template&id=85d51f32&"
import script from "./UnsubscribeTokenSettings.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeTokenSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports